import {combineReducers} from "redux";
import footballLeagueReducer from "./FootballLeagueReducer";
import ShopifyReducer from "./ShopifyReducer";
import CartReducer from "./CartReducer";
import {TimeZoneReducer} from "./TimeZoneReducer";
import {MiscReducer} from "./MiscReducer";
import {FanzineSportsReducer} from "./FanzineSportsReducer";

const reducers = combineReducers({
    football: footballLeagueReducer,
    shopify: ShopifyReducer,
    cart: CartReducer,
    timezone: TimeZoneReducer,
    misc: MiscReducer,
    fanzineSports: FanzineSportsReducer,
});

export default reducers;
